import {
  IconButton,
  Card,
  CardHeader,
  Popover,
  CardContent,
  Divider,
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ApplicationItem from "./ApplicationItem";
import axios from "axios";
import AdvertSkeleton from "../../common/components/AdvertSkeleton";
import NoResults from "../../common/components/NoResults";

const ApplicantDetails = (props) => {
  const { applicantId, showApplication, setShowApplication } = props;

  const randomArray = Array.from({ length: 1 }, () =>
    Math.floor(Math.random() * 1)
  );

  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState(null);

  useEffect(() => {
    getApplications();
  }, []);

  const getApplications = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `/api/recruitment/single-application/${applicantId}`
      );

      setApplication(data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const onClose = () => {
    setShowApplication(false);
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showApplication}
        fullWidth
        maxWidth={"lg"}
      >
        <DialogTitle>
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            View Application
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>
        <DialogContent className="mt-0 mx-0" dividers>
          <div>
            {loading && !application ? (
              randomArray.map((item) => (
                <div
                  className="mb-3"
                  key={item + Math.random() * 11}
                  role="listitem"
                >
                  <AdvertSkeleton />
                </div>
              ))
            ) : !!application ? (
              <div className="mb-3" key={application.id} role="listitem">
                <ApplicationItem application={application} />
              </div>
            ) : (
              <NoResults />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ApplicantDetails;
